<template>
  <div>
    <div class="banner page-head flex-box" style="min-height: 100px">
      <div class="w-100">
        <div class="container">
          <div class="banner-caption text-center">
            <h2 class="features-header-text ml-0 text-center">About Us</h2>
            <h5 style="color: #676767">
              Our Work is the bridge to various insightful digital experiences.
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div class="support-wrp">
      <div class="container">
        <div class="row align-items-center justify-content-between">
          <div class="col-md-7">
            <div class="support-block" data-aos="fade-left">
              <div
                class="media align-items-center"
                style="margin: 40px 0 40px 0"
              >
                <img
                  class="mr-3 js-lazy-image"
                  src="../assets/img/user.png"
                  alt
                />
                <div class="media-body">
                  <h6>Who we are?</h6>
                </div>
              </div>
              <p>
                We are a bunch of passionate geeks who are determined to
                democratize the world of Artificial Intelligence, through human
                innovation. Our vision is to develop powerful AI solutions that
                help our clients achieve business results.
              </p>
              <h3>Meet Team Geek</h3>
              <p>
                We are a young team of committed experts encompassing key areas
                of AI, especially Machine Learning, Natural Language Processing,
                Deep Learning and Business Process Reengineering. We believe in
                translating the needs of our clients and delivering solutions
                that reduce operational costs, enhance customer experience and
                bring in quantifiable increase in revenue. At Cense, we have a
                culture of constant innovation, a customer-centric approach and
                a solution-oriented team. Like most geeks, we are mostly happy
                working hard behind the scenes, but at times, we do like being
                in the spotlight.
              </p>
              <h3>Management Team</h3>
              <p>
                <b>Amit Gaonkar - CEO</b>
                <br />
                <span
                  style="font-style: italic; color: #283577; font-weight: bold"
                  >"The most effective way to do it, is to do it - Amelia
                  Earhart"</span
                >
                <br />A firm believer in the power of action, Amit has set out
                to create the best AI solutions that fundamentally and
                positively change the way businesses operate. A natural leader,
                Amit has over 20 years of rich and diverse experience in varied
                technology roles and domains. His specialties include
                Leadership, Team Building, Product Development, Machine
                Learning, Web Development & Innovation, Mobile Architecture &
                Programming in Android and Swift (iOS), Cloud Computing (SaaS &
                PaaS) and Business Process Analysis.
              </p>
              <p>
                <b>Manoj Karthikeyan - COO</b>
                <br />
                Manoj has over 20 years of experience involving Operation
                Management, Budgeting, Planning, Process definition, Analysis,
                and solution implementation Managed medium to large sized teams
                in multi-cultural onsite / offshore environment Background of
                preparation of feasibility studies, proposal preparation,
                estimation, costing of project and project profitability. Well
                experienced in Project Management and Quality Assurance
                procedures (CMM / ISO) and ISMS requirement (ISO 27001 / BS
                7799)·
              </p>
              <p>
                <b> Anand Desikan - Strategic Advisor</b>
                <br />
                Anand Desikan has over 20 years of experience building software
                and hardware products in enterprises in Digital Health, Medical
                devices, Consumer devices, SaaS, Cloud infrastructure, DevOps,
                IoT, Cybersecurity, Artificial intelligence, and Machine
                learning. Anand spearheaded the delivery of multiple Technology
                products from early-stage for B2B and scaled to revenue with
                high operating margins.
              </p>
              <!-- <p>
                <b>Shwetambari Gulhane - Head of Product</b>
                <br />
                Shwetambari has over 12 years of experience managing and leading
                consumer and enterprise products and has worked extensively with
                companies from product ideation to product launch globally. She
                is highly consumer focused and leading the team with user
                research, product innovation, product strategy, and go to market
                strategy. She is a product champion and is working on future
                product scope and vision from product MVPs to full product
                launch to generate revenue and future scalability.
              </p> -->
              <p>
                <b>Suresh Madhuvarsu - Advisor & Business Strategist</b>
                <br />
                Suresh focuses on early stage startups in Automotive,
                Construction, Talent Management industries, and brings in the
                SaaS, Mobile Apps, IoT, Chatbots, Blockchain, and Analytics
                expertise. He is passionate about productivity and collaboration
                applications across industries.
                <br> Suresh drove product strategy
                for multiple B2B SaaS and Mobile products and scaled to $100M+
                revenue in 5 years with organic growth and acquisitions. The 2
                startups he was part of went through acquisitions by Oracle &
                Software AG. Suresh enjoys mentoring and advising early-stage
                founders & leadership teams building emerging technology
                start-ups.
              </p>
            </div>
          </div>
          <div class="col-md-5">
            <div class="support-img" data-aos="fade-right">
              <img class="js-lazy-image" src="../assets/img/about.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import AOS from "aos";
export default {
  name: "about-us",
  data() {
    return {
      observer: null,
    };
  },
  mounted() {
    this.setIntersectionObserver();
  },
  methods: {
    setIntersectionObserver() {
      // Get all of the images that are marked up to lazy load
      const images = document.querySelectorAll(".js-lazy-image");
      const config = {
        // If the image gets within 50px in the Y axis, start the download.
        rootMargin: "50px 0px",
        threshold: 0.01,
      };
      // The observer for the images on the page
      // If we don't have support for intersection observer, load the images immediately
      if (!("IntersectionObserver" in window)) {
        Array.from(images).forEach((image) => preloadImage(image));
      } else {
        // It is supported, load the images
        this.observer = new IntersectionObserver(
          this.onImageIntersection,
          config
        );
        images.forEach((image) => {
          this.observer.observe(image);
        });
      }
    },
    onImageIntersection(entries) {
      // Loop through the entries
      entries.forEach((entry) => {
        // Are we in viewport?
        if (entry.intersectionRatio > 0) {
          // Stop watching and load the image
          this.observer.unobserve(entry.target);
          entry.target.src = entry.target.dataset.src.toString();
        }
      });
    },
  },
};
AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});
</script>
<style scoped>
h1,
h3,
h4 {
  font-family: "Rubik";
  font-size: 1.375rem;
  font-weight: normal;
}
h6 {
  font-family: "Rubik";
  font-size: 1.875rem;
}
.support-wrp .support-block {
  margin: 0 0 50px;
}
.support-block p {
  font-size: 1rem;
  margin: 0 0 20px;
}
</style>